import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as S from './Playlist.styles';
import * as T from './Playlist.types';
import PlaylistItem from 'components/PlaylistItem/PlaylistItem';
import Spinner from 'components/Spinner/Spinner';
import * as selectors from 'modules/Player/selectors';

export class Playlist extends PureComponent<T.IPlaylistProps> {
  onReload = () => {
    window.location.reload();
  };

  render() {
    const {
      playlistIds,
      currentlyPlayingTrackId,
      tracksById,
      isShowApiRequestPending,
      showApiRequestErrorMessage,
      isTrackApiRequestPending,
      showId,
    } = this.props;

    const isShowIdNotInitialized = Boolean(showId);
    const isShowApiRequestErrored = Boolean(showApiRequestErrorMessage);

    if (isShowApiRequestErrored) {
      return (
        <S.PlaylistWrapper className="isLoading">
          <S.ErrorMessage>
            <S.ErrorMessageMain>Chyba při načítání dat</S.ErrorMessageMain>{' '}
            {showApiRequestErrorMessage ? (
              <S.ErrorMessageSecondary>{`${showApiRequestErrorMessage}`}</S.ErrorMessageSecondary>
            ) : (
              ''
            )}
          </S.ErrorMessage>
          <S.ReloadButton onClick={this.onReload}>Načíst znovu</S.ReloadButton>
        </S.PlaylistWrapper>
      );
    }

    if (isShowApiRequestPending || (!isShowIdNotInitialized && isTrackApiRequestPending)) {
      return (
        <S.PlaylistWrapper className="isLoading">
          <Spinner />
        </S.PlaylistWrapper>
      );
    }

    if (!isShowIdNotInitialized) {
      return (
        <S.PlaylistWrapper className="isLoading">
          <S.ErrorMessage>Id pořadu nebylo možné zjistit</S.ErrorMessage>
          <S.ReloadButton onClick={this.onReload}>Načíst znovu</S.ReloadButton>
        </S.PlaylistWrapper>
      );
    }

    if (!playlistIds || !tracksById) return <S.PlaylistWrapper />;

    return (
      <S.PlaylistWrapper>
        {playlistIds.map((id, ind, arr) => {
          if (!id) {
            return null;
          }

          return (
            <PlaylistItem
              id={id}
              key={id}
              playlistPosition={arr.length - ind}
              isCurrentlyPlaying={id === currentlyPlayingTrackId}
              isTrackApiRequestPending={false}
              currentlyPlayingTrackId={null}
              isPlaylistApiRequestPending={false}
            />
          );
        })}
      </S.PlaylistWrapper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  show: selectors.getShow(state),
  showId: selectors.getShowId(state),
  playlistIds: selectors.getPlaylistIds(state),
  tracksById: selectors.getTracksById(state),
  currentlyPlayingTrackId: selectors.getCurrentlyPlayingTrackId(state),
  showApiRequestErrorMessage: selectors.getShowApiRequestErrorMessage(state),
  isShowApiRequestPending: selectors.getIsShowApiRequestPending(state),
  isTrackApiRequestPending: selectors.getIsTrackApiRequestPending(state),
});

export default connect(mapStateToProps, null)(Playlist);
